export enum CLASSES_STATUS_ENUM {
  OPEN = 'open',
  IN_PROGRESS = 'in_progress',
  FINISHED = 'finished',
  NOT_CREATED = 'not_created',
  CANCELED = 'canceled',
  DELETED = 'deleted'
}
